<template>
  <div id="chart">
    <apexchart @click="selectedBar" type="bar" height="auto" :options="chartOptions" :series="series"></apexchart>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{!!currentEvent ? currentEvent.event : ''}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row align-item-center">
              <div class="col-auto pb-2 mr-2">
                <nav aria-label="...">
                  <ul class="pagination text-smallest mb-0 pb-0">
                    <li class="page-item" :class="{ 'disabled': loading && !inspectionByFinding.length || pagination.currentPage === 1}">
                      <button class="page-link" @click="setPage(1,year,office)">First</button>
                    </li>

                    <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                      <button class="page-link" @click="setPage(page,year,office)">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                      <button class="page-link" @click="setPage(pagination.lastPage,year,office)">Last</button>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="col-auto">
                <select :disabled="loading && !inspectionByFinding.length" name="year" id="year" v-model="year" class="form-control form-control-sm">
                  <option :value="null">{{Math.min(...years)}}-{{Math.max(...years)}}</option>
                  <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                </select>
              </div>
              <div class="col-auto" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                <button class="btn btn-dark btn-sm force-white-all" :disabled="!inspectionByFinding.length" @click.prevent="generateCsv"><font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>DOWNLOAD CSV</button>
              </div>
            </div>

            <table class="small e-tbl">
              <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">

              <template v-if="$route.params.chart_module === 'number_of_findings'">
                <tr>
                  <th class="align-middle text-center" style="width: 1em" scope="col">#</th>
                  <th class="align-middle text-center" scope="col">VESSEL</th>
                  <th class="align-middle text-center" scope="col">MANAGER</th>
                  <th class="align-middle text-center" scope="col">REPORT TITLE</th>
                  <th class="align-middle text-center" scope="col">COMMENCEMENT DATE</th>
                  <th class="align-middle text-center" scope="col">CODE</th>
                  <th class="align-middle text-center" scope="col">TYPE OF FINDING</th>
                  <th class="align-middle text-center" scope="col">RISQ FINDING</th>
                  <th class="align-middle text-center" scope="col">REVISION NUMBER</th>
                  <th class="align-middle text-center" scope="col">ACTION</th>
                </tr>
              </template>
              <template v-else>
              </template>

              </thead>
              <tbody>
              <template v-if="loading && !inspectionByFinding.length">
                <tr>
                  <td colspan="100%">
                    <app-loading></app-loading>
                  </td>
                </tr>
              </template>
              <template v-else-if="!loading && inspectionByFinding.length">
                <tr v-for="(evt,index) in inspectionByFinding ">
                  <td class="align-middle text-center">{{index + 1}}</td>
                  <td class="align-middle text-center">{{evt.vessel_name}}</td>
                  <td class="align-middle text-center">{{evt.management_office_name}}</td>
                  <td class="align-middle text-center">{{evt.rs_title}}</td>
                  <td class="align-middle text-center">{{evt.inspection_commencement_date}}</td>
                  <td class="align-middle text-center">{{evt.question_code}}</td>
                  <td class="align-middle text-center">{{evt.type_of_finding}}</td>
                  <td class="align-middle text-center">{{evt.main_question}}</td>
                  <td class="align-middle text-center">{{evt.revision_number}}</td>

                  <td class="align-middle text-center">
                    <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click="showReport(evt.rs_id)">
                      <font-awesome-icon icon="eye"  />
                      View
                    </button>
                  </td>
                </tr>
              </template>
              <template v-else>
                <td colspan="100%" class="align-middle text-center">
                  <p class="h5 py-1">NO RIGHTSHIP FOUND</p>
                </td>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import appLoading from "@/components/elements/AppLoading.vue";
import {ExcelService} from "@/services/ExcelService";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "RightShipYearlyChart",
  props:{
    series:{
      type:Object | Array,
      default:null,
    },
    categories:{
      type: Array,
      default: null
    },
    years:{
      type: Array,
      default: null
    },
    categoryObject:{
      type:Array|Object,
      default:null
    },
    office:{
      type:String|Number,
      default:null,
    }
  },
  mixins:[PaginationMixin, permissionMixin],
  components:{appLoading},
  data() {
    return {
      year:null,
      loading:false,
      currentEvent:null,
      chartOptions: {
        chart: {
          type: 'bar',
          events:{
            xAxisLabelClick: function(event, chartContext, config){
              return event.target.innerHTML;
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          colors: ['#000']
        },
        tooltip: {
          followCursor : true,
          shared: true,
          intersect: false
        },
        fill: {
          colors: ['#bfbfbf', '#a6a6a6', '#ffd966', '#f7caac', '#f4b083', '#ff0000']
        },
        grid: {
          borderColor: '#e9e9e9',
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            }
          }
        },
        xaxis: {
          categories: this.categories,
        },
      },
    }
  },
  methods:{
    ...mapActions(['getInspectionByFinding']),
    async selectedBar(evt) {
      const isDownloadMenuItem = $(evt.target).hasClass('apexcharts-menu-item');
      if (isDownloadMenuItem) {
        return;
      }
      const innerText = evt.target.innerHTML;

      const code = innerText.split(')')[0].trim();

      this.currentEvent = this.categoryObject.find((evt2) => {
        const eventCode = evt2.event.split(')')[0].trim();
        return eventCode === code;
      });

      if (this.currentEvent) {
        this.$store.commit('setInspectionByFinding', []);
        $('#exampleModal').modal('show');
        this.loading = true;
        this.year = null;
        await this.setPage(null, null, this.office);
        this.loading = false;
      }
    },
    async setPage(page = null,year=null,office=null){
      if (!this.currentEvent) return;

      this.$store.commit('setInspectionByFinding', []);
      this.loading = true;

      let params = {
        finding:this.currentEvent?.eventOneId,
        page:page ?? 1,
        year:year ?? null,
        office: office ?? null
      }

      await this.getInspectionByFinding(params);
      this.loading=false;
    },
    async generateCsv(){
      swal.fire({
        'title': 'GENERATING CSV FILE',
        allowEscapeKey:false,
        allowEnterKey:false,
        allowOutsideClick:false,
      })
      swal.showLoading()
      await ExcelService.csv('RIGHTSHIP_EVENT',{finding:this.currentEvent?.eventOneId ?? null,year:this.year ?? null,office:this.office})
      swal.close();
    },
    async showReport (reportId) {
      // const routeName = this.$route.params.chart_module === 'number_of_findings' ? 'RsMain' : 'Loss'
      const route= this.$router.resolve(
        {
          name: 'RsMain',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
  },
  computed:{
    ...mapGetters(['inspectionByFinding','pagination']),
  },

  watch:{
    'year'(val){
      this.setPage(null,val,this.office)
    }
  }
}
</script>

<style scoped>
table tr td{
  font-size: 14px !important;
}
</style>
